export default "__VITE_ASSET__fHnPQOIY__"